/**
 * Etiquetas confronta: CFDI desde copia local de XML (SAT) vs Control de IVA en Excel (Contabilidad).
 */

export const CFDI_EN_SISTEMA_SAT = "CFDI cargados en el sistema (SAT)";
export const CFDI_COBRADOS_SISTEMA_SAT = "CFDI cobrados en el sistema (SAT)";
export const CFDI_RECIBIDOS_SISTEMA_SAT = "CFDI recibidos en el sistema (SAT)";
export const EXCEL_CONTABILIDAD = "Excel (Contabilidad)";
export const DESCARGAR_EXCEL_CONTAB = "Descargar Excel (Contabilidad)";
export const CARGAR_EXCEL_CONTAB_ING = "Cargar Excel (Contabilidad) — Control de IVA";
export const CARGAR_EXCEL_CONTAB_EGR = "Cargar Excel (Contabilidad) — Control de IVA (Egresos)";
export const BTN_CARGAR_EXCEL = "Cargar Excel (Contabilidad)";
export const TAB_SOLO_EXCEL = "Sólo Contabilidad";
export const TAB_SOLO_SISTEMA = "Sólo Visor SAT (CFDI)";
export const TAB_CONSIDERACIONES = "Desfase visor SAT";
export const STAT_SOLO_EXCEL = "Solo en Excel (Contabilidad)";
export const STAT_SOLO_SISTEMA = "Solo en sistema (SAT)";
export const ESTADO_SOLO_EXCEL_TABLA = "Solo en Excel (Contabilidad)";
export const BADGE_SOLO_EXCEL_CORTO = "Solo Excel (Contabilidad)";
/** Filas Excel (contabilidad) en el año del selector — no confundir con XML SAT. */
export const FILAS_INGRESO_EXCEL_CONTAB = "filas Excel ingreso (Contabilidad)";
export const FILAS_GASTO_EXCEL_CONTAB = "filas Excel egreso (Contabilidad)";
/** @deprecated usar FILAS_INGRESO_EXCEL_CONTAB — nombre histórico impreciso */
export const FILAS_INGRESO_BD_SAT = FILAS_INGRESO_EXCEL_CONTAB;
/** @deprecated usar FILAS_GASTO_EXCEL_CONTAB */
export const FILAS_GASTO_BD_SAT = FILAS_GASTO_EXCEL_CONTAB;
export const LINK_CARGAR_EXCEL_CONTADOR = "Cargar Excel (Contabilidad) del contador →";
export const TITLE_BUSCAR_CFDI = "Buscar CFDI (SAT) / Complemento de pago";
export const INTEGRACION_SALDOS_LABEL = "Integración saldos (SAT / Contabilidad)";
export const MISMO_MES_FECHAS_EXCEL = "Mismo mes · día distinto (SAT / Excel)";
export const CRITERIOS_ACORDEON = "Criterios, NC, complementos y duplicidad Excel (Contabilidad) vs sistema (SAT)";
export const TH_SUB_EXCEL = "Sub (Contabilidad)";
export const TH_IVA_EXCEL = "IVA (Contabilidad)";
export const TH_TOTAL_EXCEL = "Total (Contabilidad)";
export const TH_CFDI_SAT = "CFDI (SAT)";
export const TH_CFDI_SAT_PUE = "Sub PUE (SAT)";
export const TH_CFDI_SAT_PAGO = "Sub Pago (SAT)";
export const TH_IVA_SAT_PUE = "IVA PUE (SAT)";
export const TH_IVA_SAT_PAGO = "IVA Pago (SAT)";
export const TH_IVA_SAT = "IVA (SAT)";
export const TH_SUB_SAT = "Sub (SAT)";
export const TH_TOTAL_SAT = "Total (SAT)";
export const TH_CFDI_SIS_CORTO = "CFDI (SAT)";
export const TH_TOTAL_SIS = "Total (SAT)";
export const TAB_IVA = "IVA";
export const TITLE_CONFRONTA_INGRESO = "Confronta Cobrados — Sistema (SAT) vs Excel (Contabilidad)";
export const TITLE_CONFRONTA_EGRESO = "Confronta Pagados — Sistema (SAT) vs Excel (Contabilidad)";
export const TITLE_CONFRONTA_NOMINA = "Confronta Nóminas — Sistema (SAT) vs Excel (Contabilidad)";
export const FEC_SISTEMA_SAT = "Fec. sistema (SAT)";
export const FEC_EXCEL_CONTAB = "Fec. Excel (Contabilidad)";
export const FEC_SISTEMA_REAL_SAT = "Fec. sistema (SAT) real";
export const TOTAL_SISTEMA_SAT = "Total sistema (SAT)";
export const TOTAL_EXCEL_CONTAB = "Total Excel (Contabilidad)";
export const NO_EN_SISTEMA_SAT = "No en sistema (SAT)";
export const ROW_LABEL_CFDI_SAT = "CFDI (SAT)";
export const DIF_TOTAL_BLOQUE = "Diferencia total Sistema (SAT) − Excel (Contabilidad)";
